import axios from 'axios';
import { alertActions } from '../redux/actions/alert-actions';
import User from './User';
export const int = {
  setupInterceptors
}

function setupInterceptors(store, history, props) {
  const { dispatch } = store;
  axios.interceptors.response.use(response => {
    return response.data;
  },
    (error) => {
      if (axios.isCancel(error)) {
        return Promise.reject(error);
      }

      if (error.response) {
        if (error.response.status === 401) {
          const requestUrl = ((error.config && error.config.url) || '').toLowerCase();
          const isLoginRequest = /auth\/login|user\/login|salesforcelogin/.test(requestUrl);

          const isTwoFactorRequest = requestUrl.indexOf('auth/2fa/') !== -1;

          const path = (window.location.pathname || '').toLowerCase();

            const isAuthPage = path.startsWith('/login') || path.startsWith('/management');
            const isHome = path === '/' || path === '';

            if (!isLoginRequest && !isTwoFactorRequest) {
              localStorage.removeItem('user');
              User.user = undefined;

              const isFrontendRoute = !path.startsWith('/admin');

              if (isFrontendRoute && !isAuthPage && !isHome) {
                history.push('/Login');
              }
            }
          }

        if (error.response.data) {
          if ('errors' in error.response.data) {
            return Promise.reject(error.response.data.errors);
          }
          if ('error' in error.response.data) {
            return Promise.reject(error.response.data.error);
          }
          return Promise.reject(error.response.data);
        }

        return Promise.reject(error.response);
      }

      return Promise.reject(error);
    });

  axios.interceptors.request.use((config) => {
    // const { dispatch } = props;
    dispatch(alertActions.clear());

    return config;
  },
    (error) => {
      console.log('error 2', error);
      return Promise.reject(error);
    });
}
